import React from "react";

export default function BackToTop() {
  // Optional: Only show after scrolling a bit
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 200); // Show after 200px scroll
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null; // Don't show unless scrolled

  return (
    <a
      style={{
        position: "fixed",
        right: "2rem",
        bottom: "2rem",
        zIndex: 1000,
        background: "#007bff",
        color: "#fff",
        borderRadius: "50%",
        width: "48px",
        height: "48px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
        backgroundColor: "#d50000",
        cursor: "pointer",
        fontSize: "2rem",
        textDecoration: "none",
      }}
      title="Back to top"
      onClick={(e) => {
        e.preventDefault(); // Prevent anchor jump
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      <i className="fa fa-angle-up" />
    </a>
  );
}
